import angular from 'angular'

import fixPost from '../utils/fix-post'
import postFlag from '../utils/post-flag'
import StrictObj from '../utils/strict-obj'
import postPosition from '../utils/post-position'
import postViewIndex from '../utils/post-view-index'
import postModelIndex from '../utils/post-model-index'

import { find, castArray } from 'lodash-es'
import { attachPostInfo, attachMediaInfo } from '../utils/post-info'

angular
  .module('ggs.gallery')
  .factory('FormatPost', FormatPostProvider)

function FormatPostProvider(qh, fixYoutubeThumb) {

  return function FormatPost(properties) {
    return StrictObj({
      above,
      below
    })

    function above(input) {
      return formatPost(input, postPosition.above)
    }

    function below(input) {
      return formatPost(input, postPosition.below)
    }

    function formatPost(input, initPostPosition) {
      const posts = castArray(input)
      return qh.try(() => {
        fixPost(posts, properties)
        initPostPosition(posts)
        postFlag.init(posts)
        postViewIndex.init(posts)
        postModelIndex.index(posts)
      }).then(() => {
        return fixYoutubeThumb(posts)
      }).then(() => {
        attachPostInfo(posts)
        attachMediaInfo(posts)
        wrapByStrictObj(posts)
        return input
      })
    }

    function wrapByStrictObj(posts) {
      for (let index = 0, length = posts.length; index !== length; index++) {
        const post = posts[index] = StrictObj(posts[index])
        post.text_emoji_to_img = StrictObj(post.text_emoji_to_img)
        post.text_position_to_hashtag = StrictObj(post.text_position_to_hashtag)

        for (let index = 0, length = post.media_list.length; index !== length; index++) {
          const media = post.media_list[index] = StrictObj(post.media_list[index])
          if (media.info.isSomeText) {
            media.text_emoji_to_img = StrictObj(media.text_emoji_to_img)
            media.text_position_to_hashtag = StrictObj(media.text_position_to_hashtag)
          }
        }

        post.preview = find(post.media_list, post.preview)
      }
    }
  }
}
